import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/group_arrow.png'
import _imports_1 from '@/assets/image/leader_free.png'


const _withScopeId = n => (_pushScopeId("data-v-811c8eb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"font-size":"32px","color":"red"} }
const _hoisted_2 = { style: {"font-size":"32px","color":"red"} }
const _hoisted_3 = { style: {"font-size":"32px","color":"red"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "group-divider",
  src: _imports_0,
  alt: "xx"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "group-divider",
  src: _imports_0,
  alt: "xx"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "group-divider",
  src: _imports_0,
  alt: "xx"
}, null, -1))
const _hoisted_7 = {
  key: 2,
  class: "leader-free"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "leader free"
}, null, -1))

import {editor} from "@/app/editor";
import {GroupModuleV1} from "@/app/editor/modules/group/v1/index";
import {computed} from "vue";
import FrameContentPreview from "@/app/editor/views/FrameContentPreview.vue";
import GiftPreview from "@/app/editor/views/GiftPreview.vue";
import GroupTransactionsView from "@/app/editor/modules/group/v1/view/GroupTransactionsView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupPreview',
  props: {
    index: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "0511a62c": (cssBg.value)
}))

const props = __props
const group = editor.activity?.modules[props.index] as GroupModuleV1
const cssBg = computed(() => '#' + editor.activity?.data.themes.find(t => t.theme_id == editor.activity?.status.theme_props.theme_id)?.color)

const groupSteps = computed(() => {
  return group.config.steps.filter(s => s.items.filter(i => i.category == '组团优惠').length > 0)
})

const gift4All = computed(() => {
  return group.config.steps.filter(s => s.items.filter(i => i.category == '全员福利').length > 0)
})

const gift4Leader = computed(() => {
  return group.config.steps.filter(s => s.items.filter(i => i.category == '团长福利').length > 0)
})


return (_ctx: any,_cache: any) => {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_flex = _resolveComponent("a-flex")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(`section_${_ctx.index}`)
    }, null, 2),
    (_unref(group))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (groupSteps.value.length>0)
            ? (_openBlock(), _createBlock(FrameContentPreview, {
                key: 0,
                title: "组团优惠"
              }, {
                default: _withCtx(() => [
                  (_unref(group).config.type == '价格阶梯团')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_unref(group).config.fail_items.length>0)
                          ? (_openBlock(), _createBlock(_component_a_divider, { key: 0 }))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupSteps.value, (s) => {
                          return (_openBlock(), _createBlock(_component_a_typography_title, {
                            key: s.group_size,
                            level: 2,
                            style: {"margin":"10px 0 0 0","color":"red"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(s.group_size) + "人组团只需 " + _toDisplayString(s.price) + "元 ", 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        (groupSteps.value.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(groupSteps.value[0].items.filter(i => i.category == '组团优惠'), (i, ii) => {
                              return (_openBlock(), _createBlock(_component_a_typography_title, {
                                key: ii,
                                level: 4
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(i.title) + " ", 1),
                                  _createElementVNode("span", _hoisted_1, "x" + _toDisplayString(i.amount), 1),
                                  _createTextVNode(" 价值" + _toDisplayString(i.value) + "元 ", 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(groupSteps.value, (s) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: s.group_size
                        }, [
                          _createVNode(_component_a_typography_title, {
                            level: 2,
                            style: {"color":"red"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(s.group_size) + "人组团成功", 1)
                            ]),
                            _: 2
                          }, 1024),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.items.filter(i => i.category == '组团优惠'), (i, ii) => {
                            return (_openBlock(), _createBlock(_component_a_typography_title, {
                              key: ii,
                              level: 4
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(i.title) + " ", 1),
                                _createElementVNode("span", _hoisted_2, "x" + _toDisplayString(i.amount), 1),
                                _createTextVNode(" 价值" + _toDisplayString(i.value) + "元 ", 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ], 64))
                      }), 128)),
                  (_unref(group).config.fail_items.length>0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (_unref(group).config.fail_items.length>0)
                          ? (_openBlock(), _createBlock(_component_a_divider, { key: 0 }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_typography_title, {
                          level: 2,
                          style: {"margin":"10px 0 0 0","color":"red"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 未成团" + _toDisplayString(_unref(group).config.type == '价格阶梯团' ? `需${_unref(group).config.steps.first()?.price ?? 0}元` : ''), 1)
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(group).config.fail_items, (i, ii) => {
                          return (_openBlock(), _createBlock(_component_a_typography_title, {
                            key: ii,
                            level: 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(i.title) + " ", 1),
                              _createElementVNode("span", _hoisted_3, "x" + _toDisplayString(i.amount), 1),
                              _createTextVNode(" 价值" + _toDisplayString(i.value) + "元 ", 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_typography_text, { style: {"margin-top":"8px","color":"gray","font-size":"12px","display":"block"} }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 所有优惠团长、成员都能得 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(FrameContentPreview, { title: "开团方式" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_flex, {
                class: "way",
                vertical: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "large",
                    type: "dashed",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("点击下方“" + _toDisplayString(_unref(editor).activity.status.buy_button_text) + "”", 1)
                    ]),
                    _: 1
                  }),
                  _hoisted_4,
                  _createVNode(_component_a_button, {
                    size: "large",
                    type: "dashed",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("支付" + _toDisplayString(_unref(editor).activity.status.sell_price) + "元即可成为团长", 1)
                    ]),
                    _: 1
                  }),
                  _hoisted_5,
                  _createVNode(_component_a_button, {
                    size: "large",
                    type: "dashed",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("咨询店家组团")
                    ]),
                    _: 1
                  }),
                  _hoisted_6,
                  _createVNode(_component_a_button, {
                    size: "large",
                    type: "dashed",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("组团成功")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (gift4All.value.length>0)
            ? (_openBlock(), _createBlock(FrameContentPreview, {
                key: 1,
                title: "全员福利"
              }, {
                default: _withCtx(() => [
                  (_unref(group).config.type == '价格阶梯团')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(gift4All.value.first()?.items.filter(i => i.category == '全员福利'), (i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: i.title
                        }, [
                          _createVNode(_component_a_typography_title, {
                            level: 4,
                            style: {"color":"red","margin":"10px 0 0 0"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 每人各得 ")
                            ]),
                            _: 1
                          }),
                          (i.gift)
                            ? (_openBlock(), _createBlock(GiftPreview, {
                                key: 0,
                                gift: i.gift,
                                amount: i.amount
                              }, null, 8, ["gift", "amount"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(gift4All.value, (s) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: s.group_size
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.items.filter(i => i.category == '全员福利'), (i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: i.title
                            }, [
                              _createVNode(_component_a_typography_title, {
                                level: 4,
                                style: {"color":"red","margin":"10px 0 0 0"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(s.group_size) + "人成团 每人各得 ", 1)
                                ]),
                                _: 2
                              }, 1024),
                              (i.gift)
                                ? (_openBlock(), _createBlock(GiftPreview, {
                                    key: 0,
                                    gift: i.gift,
                                    amount: i.amount
                                  }, null, 8, ["gift", "amount"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ], 64))
                      }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(group).config.goods.leader_free || gift4Leader.value.length > 0)
            ? (_openBlock(), _createBlock(FrameContentPreview, {
                key: 2,
                title: "团长福利"
              }, {
                default: _withCtx(() => [
                  (_unref(group).config.type == '价格阶梯团')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(gift4Leader.value.first()?.items.filter(i => i.category == '团长福利'), (i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: i.title
                        }, [
                          _createVNode(_component_a_typography_title, {
                            level: 4,
                            style: {"color":"red","margin":"10px 0 0 0"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("团长得 ")
                            ]),
                            _: 1
                          }),
                          (i.gift)
                            ? (_openBlock(), _createBlock(GiftPreview, {
                                key: 0,
                                gift: i.gift,
                                amount: i.amount
                              }, null, 8, ["gift", "amount"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(gift4Leader.value, (s) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: s.group_size
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.items.filter(i => i.category == '团长福利'), (i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: i.title
                            }, [
                              _createVNode(_component_a_typography_title, {
                                level: 4,
                                style: {"color":"red","margin":"10px 0 0 0"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(s.group_size) + "人成团 团长得 ", 1)
                                ]),
                                _: 2
                              }, 1024),
                              (i.gift)
                                ? (_openBlock(), _createBlock(GiftPreview, {
                                    key: 0,
                                    gift: i.gift,
                                    amount: i.amount
                                  }, null, 8, ["gift", "amount"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ], 64))
                      }), 128)),
                  (_unref(group).config.goods.leader_free)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("span", null, _toDisplayString(_unref(group).config.steps.last().group_size) + "人组团成功", 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})